import React from 'react';
import { Box } from '@mui/material';

function Intro() {
  return (
    <Box sx={{ flexGrow: 1, m: 4, px: 2 }}>
      <p>
        <i>
          A reproduction of the{' '}
          <a
            href="https://s3.us-east-1.amazonaws.com/142892152840-madlib.anthonyjamespearson.com/original/lab3.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            original
          </a>
          . View the source on{' '}
          <a
            href="https://github.com/ajgoldenwings/ajp-madlib"
            rel="noopener noreferrer"
            target="_blank"
          >
            GitHub.
          </a>
        </i>
      </p>
    </Box>
  );
}

export default Intro;